// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"{'is-negative-charge' : row.entity.amount < 0 && row.entity.charge}\" ng-bind=\"row.entity.charge | invEmpty\"></div>\n</div>\n";
// Exports
module.exports = code;